import { inject, Injectable } from '@angular/core';
import { CanActivate, CanActivateFn, Router } from '@angular/router';
import { RegistrationStore } from './registration-store';

@Injectable({ providedIn: 'root' })
export class RegistrationFlowGuard implements CanActivate {

  private readonly store = inject(RegistrationStore);
  private readonly router = inject(Router);

  canActivate(): boolean {
    if (this.store.hasCompletedRegistration()) {
      console.debug('Registration complete')
      return true;
    }
    console.error('Incomplete registration');
    this.router.navigate(['../']); // back to registration page
    return false;
  }
}
